import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Chip } from 'react-materialize';

class KeywordDensity extends Component {
  shouldComponentUpdate(nextProps) {
    const { keywordDensity } = nextProps;
    return keywordDensity !== this.props.keywordDensity;
  }

  render() {
    const { keywordDensity, occurrence } = this.props;
    return (
      <div className="valign-wrapper keyword-density" style={{display: 'inline-flex', height: 'valign-wrapper'}}>
        <div
          className="tooltipped"
          data-position="top"
          data-delay="50"
          data-tooltip="keyword frequency / word count"
        >
          <Chip>Density: {keywordDensity ? <span className="keyword-density">{keywordDensity}</span> : null}%</Chip>
        </div>
        <div
          className="tooltipped"
          data-position="top"
          data-delay="50"
          data-tooltip="# of times a kw appears on page"
        >
          <Chip>Frequency: {occurrence ? <span className="keyword-occurrence">{occurrence}</span> : null}</Chip>
        </div>
      </div>
    );
  }
}

function mapStateToProps({ keywordDensity, occurrence }) {
  return { keywordDensity, occurrence };
}

export default connect(mapStateToProps)(KeywordDensity);



// WEBPACK FOOTER //
// ./src/components/Dashboard/KeywordDensity.js